import classNames from 'classnames';
import styles from './CardIcon.module.scss';
const CardIcon = ({ icon, image, color, className }) => {
  return (
    <div className={classNames(styles['wrapper'], className)}>
      <div
        className={classNames(styles['border'], {
          [styles['has-color']]: !!color,
        })}
        style={{ '--color': color }}
      ></div>
      <div className={classNames(styles['icon'])}>{image ?? icon}</div>
    </div>
  );
};
export { CardIcon as default, CardIcon };
